<template>
  <div
    v-if="showDeliveryEstimationDate && inStock"
    class="mt-2.5 inline-flex items-center gap-x-2 text-base"
  >
    <IconCircleGreen
      class="size-4"
      :class="{
        'text-green': !isDelayedDelivery,
        'text-yellow': isDelayedDelivery,
      }"
    />
    <p>
      {{ deliveryEstimationDate }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { Product, Variant } from '@scayle/storefront-nuxt'
import { isInStock } from '@scayle/storefront-nuxt'
import { getDeliveryEstimationInDays } from '../../../../../utils/shopConfiguration'
import {
  getDeliveryDaysEstimation,
  getDeliveryEstimationDate,
} from '../../../../../utils/date'
import { isPremiumClubProduct } from '~/utils/product'

const DELAYED_DELIVERY_CUTOFF_IN_DAYS = 21

const props = defineProps({
  activeVariant: {
    type: Object as PropType<Variant>,
    required: false,
    default: undefined,
  },
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  shopConfiguration: {
    type: Object as PropType<
      ReturnType<typeof useSmartShopConfiguration>['data']['value']
    >,
    required: true,
  },
})
const inStock = computed((): boolean => {
  return props.activeVariant ? isInStock(props.activeVariant) : false
})

const isDelayedDelivery = computed(() => {
  const daysTilDelivery = getDeliveryDaysEstimation(
    props.activeVariant,
    deliveryEstimationInDays.value,
  )
  return daysTilDelivery && daysTilDelivery > DELAYED_DELIVERY_CUTOFF_IN_DAYS
})

const deliveryEstimationInDays = computed(() =>
  getDeliveryEstimationInDays(props.shopConfiguration),
)

const deliveryEstimationDate = computed(
  () =>
    getDeliveryEstimationDate(
      props.activeVariant,
      deliveryEstimationInDays.value,
    ) || '',
)

const showDeliveryEstimationDate = computed(
  () => deliveryEstimationDate.value && !isPremiumClubProduct(props.product),
)
</script>
